
import { defineComponent, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { DatetimePicker,Popup ,Toast,Icon} from "vant";
import dayjs from "dayjs"
import Account from "@/api/account";
export default defineComponent({
  name: "visit",
 components: {
    "van-datetime-picker": DatetimePicker,
       "van-popup": Popup,
        "van-icon": Icon,
  },
  setup() {
    document.title = "访问量统计";
    const teacher_num = ref(0);
    const parent_num = ref(0);
    const time_num = ref(1);
   const  beginShow = ref(false);
   const  endShow = ref(false);
 
    const begin= ref('');
      const end= ref('');
  const endDate= ref(new Date());
  begin.value=dayjs().subtract(7, 'day').format('YYYY-MM-DD');
  end.value=dayjs(new Date()).format('YYYY-MM-DD');
   const beginDate= ref(new Date(begin.value));
    const route = useRoute();
    const time = (i: number) => {
      time_num.value = i;
      getanalyseUv();
    };

   const onConfirm = (val:any) => {
      begin.value=dayjs(val).format('YYYY-MM-DD')
     beginShow.value=false
          if(dayjs(begin.value).unix() > dayjs(end.value).unix()) return  Toast.fail('开始时间不能低于结束时间')
     getanalyseUv();
    };
      const onConfirmDnd = (val:any) => {
      end.value=dayjs(val).format('YYYY-MM-DD')
        endShow.value=false
     if(dayjs(begin.value).unix() > dayjs(end.value).unix()) return  Toast.fail('开始时间不能低于结束时间')
         getanalyseUv();
 };

    const onCancel = () => {
     beginShow.value=false
     endShow.value=false
    };
    
    const getanalyseUv = async () => {

        let datas:any = {
          timespan: time_num.value,
        school_id: route.query.school_id
        }

        if( time_num.value===4){
            datas = {
                 timespan: time_num.value,
        school_id: route.query.school_id,
        begin:dayjs(begin.value).unix(),
        end: dayjs(end.value).unix()
        }
            
        }
      const [err, data] = await Account.getanalyseUv(datas);
      if (err) return;
      teacher_num.value = data.teacher_number;
      parent_num.value = data.parent_number;
    };

    onMounted(() => {
      getanalyseUv();
    });

    return {
      teacher_num,
      parent_num,
      time_num,
      time,
      beginDate,
      endDate,
      begin,
      end,
      maxDate:new Date(),
      beginShow,
       endShow,
      onConfirm,
      onCancel,
      onConfirmDnd,
    };
  }
});
